<template lang="pug">
.content(@scroll.passive="onScroll", ref="content")
  .parallax
    //- .bg(:style="{ transform: 'translate3d(0, ' + bgOffset + 'px, 0)' }")
    .three-overlay(ref="threeCanvas")
    .layers
      .layer10(
        v-for="(line, i) in lines",
        :key="i",
        :style="{ transform: 'translateY(' + layerOffset(i) + 'px)' }"
      )
        | {{ line }}
</template>

<script>
import * as THREE from "three";
export default {
  metaInfo: {
    title: "Über mich",
  },
  data() {
    return {
      scrollY: 0,
      ticking: false,
      lastScroll: 0,
      lines: [
        "Mein Fundament: Abgeschlossenes Studium zum EDV-Kaufmann",
        "Über 40 Jahre gewachsene Expertise in der Softwareentwicklung",
        "Spezialist für moderne Web-Architekturen mit JavaScript und TypeScript",
        "Ästhetik trifft Struktur: Webdesign mit HTML/Pug und CSS/Less",
        "Effiziente Datenhaltung: Erfahrener Datenbankdesigner für MySQL",
        "Moderne Frontend-Entwicklung mit Fokus auf das Vue.js Ökosystem",
        "Faszination 3D: Komplexe Programmierung mit Three.js",
        "Präzision im Raum: 3D-Design mit SketchUp",
        "Visuelle Gestaltung und Grafik-Design mit Xara",
        "Die Anfänge: 2 Jahre Großrechner-Support in Danzig (Bauindustrie)",
        "14 Jahre Full-Stack Entwicklung für den Schuheinzelhandel in Dortmund",
        "25 Jahre unternehmerische Verantwortung: Mitgesellschafter und Entwickler für Branchenlösungen",
        "November 2022: Der Schritt in die Selbstständigkeit an der Ostsee (Grömitz)",
        "Heute: Ihr Partner für innovative Softwarelösungen in Emmerich am Rhein",
      ],
    };
  },
  mounted() {
    this.initThree();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
    this.stopAnimation = true;
    if (this.renderer) {
      this.renderer.dispose();
      this.renderer.forceContextLoss();
    }
  },
  computed: {
    bgOffset() {
      return this.scrollY * 0.4; // Hintergrund bewegt sich langsamer
    },
  },
  methods: {
    initThree() {
      const container = this.$refs.threeCanvas;

      // 1. Scene & Camera
      this.scene = new THREE.Scene();
      // Eine flache Kamera für den "Bild"-Look
      this.camera = new THREE.PerspectiveCamera(
        75,
        container.clientWidth / container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.z = 5;

      // 2. Renderer
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);

      // 3. Textur laden (Dein Emmerich Bild)
      const loader = new THREE.TextureLoader();
      loader.load("/img/emmerich5.jpg", (texture) => {
        const image = texture.image;
        const aspectRatio = image.width / image.height;

        // Wir legen eine feste Breite fest (z.B. 10 Einheiten)
        // und berechnen die Höhe basierend auf dem Bildformat
        const planeWidth = 10;
        const planeHeight = planeWidth / aspectRatio;

        this.geometry = new THREE.PlaneGeometry(
          planeWidth,
          planeHeight,
          128,
          128
        );

        // Material, das auf Licht reagiert (MeshStandardMaterial)
        this.material = new THREE.MeshStandardMaterial({
          map: texture,
          transparent: true,
          side: THREE.DoubleSide,
          flatShading: false, // Für weiche Wellen
        });

        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.scene.add(this.mesh);

        // Kopie der ursprünglichen Vertices für die Berechnung
        this.originalVertices = this.geometry.attributes.position.array.slice();
      });

      // 4. Beleuchtung hinzufügen (Wichtig für MeshStandardMaterial)
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5); // Grundlicht
      this.scene.add(ambientLight);
      this.spotLight = new THREE.SpotLight(0xffffff, 1); // Dynamisches Spotlicht
      this.spotLight.position.set(0, 5, 10);
      this.scene.add(this.spotLight);

      window.addEventListener("resize", this.onWindowResize);
      this.animate();
    },
    onWindowResize() {
      const container = this.$refs.threeCanvas;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    animate() {
      if (this.stopAnimation) return;
      requestAnimationFrame(this.animate);

      if (this.mesh && this.originalVertices) {
        const time = Date.now() * 0.001; // Zeit-Faktor für fortlaufende Bewegung
        const positions = this.geometry.attributes.position.array;

        // Durch alle Vertices loopen (jeder 3. Wert ist z)
        for (let i = 0; i < positions.length; i += 3) {
          const x = this.originalVertices[i];
          const y = this.originalVertices[i + 1];

          // --- DER WELLEN-EFFEKT ---
          // Kombiniert Sinus-Wellen basierend auf Zeit, X-Position und Scroll-Position
          const waveX = Math.sin(x * 0.5 + time + this.scrollY * 0.005);
          const waveY = Math.sin(y * 0.3 + time + this.scrollY * 0.002);

          // Z-Position (Tiefe) manipulieren
          positions[i + 2] = (waveX + waveY) * 0.15; // 0.15 ist die Wellenhöhe
        }

        // Three.js mitteilen, dass sich die Geometrie geändert hat
        this.geometry.attributes.position.needsUpdate = true;

        // Sanfte Drehung des Bildes
        this.mesh.rotation.y = this.scrollY * 0.0001;
      }

      this.renderer.render(this.scene, this.camera);
    },
    onScroll() {
      this.lastScroll = this.$refs.content.scrollTop;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimationFrame(() => {
          this.scrollY = this.lastScroll;
          this.ticking = false;
        });
      }
    },
    layerOffset(i) {
      return i * 5 - this.scrollY * 0.05; // leichter Parallax für Text
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  flex: 1 1 auto;
  overflow-y: auto;
  height: 100%;
  position: relative;
}

.three-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none; // Damit man durch das 3D-Bild hindurch scrollen/klicken kann
}

.parallax {
  position: relative;
  min-height: 2000px;
  background-color: #000;
  overflow: hidden;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 120%;
    background: url("/img/emmerich5.jpg") center/cover no-repeat;
    will-change: transform;
    z-index: 0;
  }

  /* 👇 halbtransparentes, dunkles Overlay über dem Bild */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5); // 45 % Abdunkelung
    z-index: 1;
  }

  .layers {
    position: relative;
    z-index: 2;
    color: #fff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
    padding: 20vh 5vw;
    font-size: 1.4em;
    text-align: left;

    .layer10 {
      margin: 2.5rem 0;
      font-weight: 400;
      line-height: 1.4;
      // Sanfter Übergang für die Bewegung
      transition: transform 0.1s linear;
    }
  }
}
</style>